import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit } from "@angular/core";

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
p.blue {
  color: blue;
}`],
})
export class PageMainComponent implements OnInit {
    constructor() {
    }

    public async ngOnInit() {
    }
}

export default PageMainComponent;